import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-job-status-pill',
    standalone: true,
    template: `
        <span class="job-status-pill"
            [class.job-status-open]="state === 'open'"
            [class.job-status-closed]="state === 'closed'"
            [class.job-status-lead]="state === 'open' && stage === 'lead'"
        >{{ label || defaultLabel }}</span>
    `,
    styles: [`
        .job-status-pill {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0 0.6rem;
            border-radius: 2rem;
            font-size: 0.75rem;
            font-weight: 600;
            line-height: 1.4rem;
            white-space: nowrap;
            background: var(--surface-200);
            color: var(--text-color);
        }

        .job-status-open {
            background-color: #1f7a1f;
            color: white;
        }

        .job-status-lead {
            background-color: #9a5b13;
            color: white;
        }

        .job-status-closed {
            background-color: #9e9e9e;
            color: white;
        }
    `],
})
export class JobStatusPillComponent {
    @Input() state: string | undefined;
    @Input() stage: string | undefined;
    @Input() label: string | '';

    get defaultLabel(): string {
        const s = this.state ? this.state.charAt(0).toUpperCase() + this.state.slice(1) : '';
        const st = this.stage ? this.stage.charAt(0).toUpperCase() + this.stage.slice(1) : '';
        return [s, st].filter(Boolean).join(' ') || '--';
    }
}